import { Link } from "react-router-dom";
import { Menu, Home, User, Sparkles, Flame, Gift } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { LogoMark } from "./Logo";
import { useAuth } from "../context/AuthContext";

const ITEMS = [
  { icon: Home, bg: "#C9A05A", iconColor: "text-white" },
  { icon: User, bg: "#5C1E28", iconColor: "text-white" },
  { icon: Sparkles, bg: "#D97B8F", iconColor: "text-white" },
  { icon: Flame, bg: "#C03B4A", iconColor: "text-white" },
  { icon: Gift, bg: "#EBD08A", iconColor: "text-ink" },
];

// Menu déroulant APINITY, identique sur toutes les pages (dark = sur fond bordeaux)
// Les infos légales et le contact restent dans le pied de page uniquement.
export const NavMenu = ({ dark = false }) => {
  const { user } = useAuth();
  const links = [
    { to: "/", testid: "nav-menu-home-link", title: "Accueil APINITY", sub: "Revenir à la page d'accueil" },
    { to: user ? "/mon-compte" : "/auth?mode=login", testid: "nav-menu-account-link", title: "Mon compte", sub: user ? "Matchs, chat, tirage et réservations" : "Connectez-vous pour retrouver vos matchs" },
    { to: user ? "/quiz" : "/auth?mode=register", testid: "nav-menu-start-link", title: user ? "Entrer dans le jeu" : "Commencer le jeu", sub: "Le test de compatibilité en 10 questions" },
    { to: "/speed-dating", testid: "nav-menu-speed-link", title: "Speed Dating", sub: "Des rencontres en vrai, à Saint-Germain-en-Laye" },
    { to: "/offrir", testid: "nav-menu-gift-link", title: "Offrir un test", sub: "La carte mystère à offrir par email" },
  ];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          aria-label="Menu"
          data-testid="nav-menu-button"
          className={`flex h-11 w-11 items-center justify-center rounded-full shadow-boho ring-2 ring-gold/60 transition-all duration-300 hover:scale-105 ${
            dark ? "bg-gold text-[#4A0D1A] hover:bg-gold-light" : "bg-terra text-cream hover:bg-terra-dark"
          }`}
        >
          <Menu size={19} strokeWidth={2.4} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-72 rounded-3xl border border-gold/50 bg-cream/95 p-2.5 shadow-card backdrop-blur-md" data-testid="nav-menu-dropdown">
        <div className="flex items-center gap-2.5 px-3 pb-2 pt-2.5">
          <LogoMark size={26} />
          <div>
            <p className="font-cinzel text-[11px] font-semibold tracking-[0.3em] text-ink">APINITY</p>
            <p className="text-[9px] font-semibold uppercase tracking-[0.25em] text-gold">Happy Affinity</p>
          </div>
        </div>
        <div className="mx-3 mb-1.5 h-px bg-gold/30" />
        {links.map((l, i) => {
          const Icon = ITEMS[i].icon;
          return (
            <DropdownMenuItem key={l.to} asChild className="cursor-pointer rounded-2xl px-3 py-3 transition-colors focus:bg-gold-light/70">
              <Link to={l.to} data-testid={l.testid} className="flex items-center gap-3">
                <span
                  className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full shadow-boho ${ITEMS[i].iconColor} ${ITEMS[i].bg ? "" : "border border-gold/50 bg-gold-light"}`}
                  style={ITEMS[i].bg ? { backgroundColor: ITEMS[i].bg } : undefined}
                >
                  <Icon size={17} />
                </span>
                <span className="flex flex-col items-start">
                  <span className="font-serif text-base font-semibold text-ink">{l.title}</span>
                  <span className="text-[11px] text-stone2">{l.sub}</span>
                </span>
              </Link>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
